module.exports = __webpack_public_path__ + "static/media/logo-dark.771d2b01.png";